import axios from 'axios';
import Bouncer from 'formbouncerjs/src/js/bouncer/bouncer';

const FormularioInvistaConosco = () => {
    const components = document.querySelectorAll('[data-modal="quero-investir"]');

    components.forEach(component => {
        const form = component.querySelector('form');
        new Bouncer('#invistaConosco', {
            disableSubmit: true,
            messageAfterField: false,
            messages: {
                missingValue: {
                    checkbox: '',
                    radio: '',
                    select: '',
                    'select-multiple': '',
                    default: 'Campo de preenchimento obrigatório',
                },
                patternMismatch: {
                    email: 'Por favor, insira um e-mail válido',
                    telefone: 'Por favor, insira um telefone válido',
                    default: 'Formato inválido',
                },
            },
            emitEvents: true,
        });

        form.addEventListener('bouncerFormValid', async (event) => {
            event.preventDefault();
            event.target.querySelector('[type="submit"]').setAttribute('disabled', 'disabled');

            const recaptchaInput = formEl.querySelector("input[name='recaptcha_token']");
            const recaptchaFieldName = recaptchaInput?.name || 'recaptcha_token';
            const recaptchaAction = formEl.dataset.recaptchaAction || 'fale_conosco';

            if (window.grecaptcha && window.reloadCaptcha) {
                await new Promise((resolve) => {
                    window.reloadCaptcha(recaptchaAction, recaptchaFieldName, resolve);
                });
            }

            const formData = new FormData(event.target);
            const formObject = {};

            formData.forEach((value, key) => {
                formObject[key] = value;
            });

            axios.post(`${appConfig.baseApiUrl}basedigital/v1/invista_conosco/`, formObject, {
                headers: {
                    'Content-Type': 'application/json',
                }
            }).then((response) => {
                form.reset();
                event.target.querySelector('[type="submit"]').removeAttribute('disabled');
                if (response.status === 200) {
                    form.querySelector('.success').classList.add('active');
                } else {
                    form.querySelector('.success').classList.add('active');
                }
                console.log(response);
            }).catch(() => {
                form.querySelector('.error').classList.add('active');
            });
        });
    });
};

export default FormularioInvistaConosco;

if (document.querySelectorAll('[data-modal="quero-investir"]')) {
    FormularioInvistaConosco();
}
